function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Component_122_1",
  "data-name": "Component 122 \\u2013 1",
  transform: "translate(1.007 1)"
}, React.createElement("path", {
  id: "Path_1018",
  "data-name": "Path 1018",
  d: "M1095.06,518.667c-.256-1.323-.853-1.366-1.451-1.75s-1.238-3.031-1.28-5.421-.6-6.616-4.866-7.512a1.585,1.585,0,0,0-3.158,0c-4.269.9-4.823,5.122-4.866,7.512s-.683,5.037-1.281,5.421-1.2.427-1.451,1.75.9,1.2.9,1.2h16.561S1095.316,519.99,1095.06,518.667Z",
  transform: "translate(-1076.669 -502.533)",
  fill: "none",
  stroke: "#505050",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("path", {
  id: "Path_1019",
  "data-name": "Path 1019",
  d: "M1094.589,535.6a3.671,3.671,0,0,1-7.342,0",
  transform: "translate(-1081.703 -518.271)",
  fill: "none",
  stroke: "#505050",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20.44,
    height: 23,
    viewBox: "0 0 20.44 23",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.2ff7e2b6.svg";
export { ForwardRef as ReactComponent };